var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-elements"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('vuestic-widget',{attrs:{"headerText":"Alunos"}},[_c('FormAluno')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }